export const isPhoneInvalid = (phone: string): boolean =>
  !/0[0-9]{9}$/.test(phone);
